<template>
    <div class="forgot-anime">
        <h2>{{ h2Text }}</h2>
        <div class="forgot-block">
            <div class="forgot-form">
                <form v-if="isEmailSend" onsubmit="return false">
                    <label for="">Ваш Email</label>
                    <input v-model="email" type="email">
                    
                    <button @click="sendResetPageToEmail()" class="forgot-button">Отправить</button>
                </form>
            </div>
        </div>
    </div>
    
  </template>
  
  <script>
  import axios from "axios";
 
  
  export default {
    data() {
      return {
        url: 'https://anione.fun/api/forgot.php?email=',
        email: '',
        h2Text: 'Забыли пароль?',
        isEmailSend: true
      };
    },
    watch:{
      
    },
    mounted(){
      
    },
    methods: {
        sendResetPageToEmail: function(){
            
            if(this.validateEmail(this.email)){
                axios
                .get(this.url + this.email)
                .then((response) => {
                    console.log(response.data);
                    if(response.data === 'Message has been sent'){
                        this.isEmailSend = false;
                        this.h2Text = 'Ссылка для сброса пароля отправлена на указанную почту. Не забудьте проверить папку "Спам".';
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
            }
            
        },
        validateEmail: function(email){
            return String(email)
            .toLowerCase()
            .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
        }
    }
    
  };
  </script>
  
<style>

.forgot-form {
    display: flex;
    width: 300px;
    flex-direction: column;
}

.forgot-form form{
    widows: 100%;
}


.forgot-block {
    display: flex;
    justify-content: center;
}

.forgot-form {
    display: flex;
    width: 300px;
    flex-direction: column;
}

.forgot-anime .forgot-form label {
    padding: 10px 0 5px 0;
    font-family: 'Montserrat', sans-serif;
}

.forgot-anime .forgot-form input {
    width: 100%;
    padding: 8px 10px;
    border-radius: 8px;
    border: none;
    font-family: 'Exo 2', sans-serif;
    font-size: 18px;
    margin-top: 6px;
}

.forgot-anime .forgot-form .forgot-button {
    color: white;
    background-color: #0d6efd;
}

.forgot-anime .forgot-form button {
    padding: 5px 10px;
    border: none;
    border-radius: 8px;
    font-size: 18px;
    font-family: 'Montserrat';
    margin-top: 10px;
    cursor: pointer;
}
  </style>